import { parseISO, differenceInSeconds } from 'helpers/intl-helper';

import { gql, useQuery } from '@apollo/client';

const COMPANY_TRIAL_END = gql`
  query CompanyTrialEnd {
    viewer {
      id
      company {
        id
        databaseId
        sampleEnd
        trialEnd
        trialed
      }
    }
  }
`;

const useTrialEndDays = () => {
  const { data } = useQuery(COMPANY_TRIAL_END);
  const company = data?.viewer?.company;
  const trialEnd = company?.trialEnd;
  const isoSampleEnd = parseISO(company?.sampleEnd);
  const isoTrialEnd = parseISO(trialEnd);
  const trialDaysRemaining = differenceInSeconds(isoTrialEnd, new Date());
  const sampleDaysRemaining = differenceInSeconds(isoSampleEnd, new Date());
  const hasTrialDaysRemaining = trialDaysRemaining > 0;
  const hasSampleDaysRemaining = sampleDaysRemaining > 0;

  return {
    hasTrialDaysRemaining,
    hasSampleDaysRemaining,
    isoSampleEnd,
    isoTrialEnd,
    trialEnd,
  };
};

export default useTrialEndDays;
